'use client';

import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { useUserState } from '@entities/user';

import routes from '@shared/routes';

const GuestGuard: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const { status } = useUserState();

  useEffect(() => {
    if (status === 'authenticated') {
      router.replace(routes.merchants);
    }
  }, [router, status]);

  if (status === 'initializing') {
    return null;
  }

  if (status === 'authenticated') {
    return null;
  }

  return children;
};

export default GuestGuard;
